"use client";
import React from "react";
import { Comment } from "./Comment";

export const CommentList = ({ comments }) => {
  if (!comments || comments.length === 0) {
    return (
      <div className="py-4 text-center text-gray-500 text-sm">
        No comments yet. Be the first to comment!
      </div>
    );
  }

  return (
    <div className="space-y-1">
      {comments.map((comment) => (
        <Comment key={comment.id} comment={comment} />
      ))}
    </div>
  );
};
